<template>
  <section>
    <div class="main" v-if="$route.name=='tridev'">
      <div class="w_breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <i class="iconfont icondqwz"></i>
          <el-breadcrumb-item
            :to="{ path: '/systemConfiguration/allSystemConfiguration/device/allDevice/device/trigger' }"
          >阈值管理</el-breadcrumb-item>
          <el-breadcrumb-item>阈值关联</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <el-tabs class="tabLv3" type="border-card" v-model="relevanceType">
        <i class="lt"></i>
        <i class="rt"></i>
        <el-tab-pane name="1">
          <span slot="label">
            <i class="iconfont iconcheck"></i>
            <i class="border"></i> 关联设备
          </span>
          <div class="w_normalNav">
            <button class="GreenSmBtn" @click="contact">新增</button>
          </div>
          <div
            class="table"
            v-loading="loading1"
            element-loading-text="拼命加载中"
            element-loading-spinner="el-icon-loading"
          >
            <el-table :data="tableData2" stripe class="stripeTable" style="width: 100%">
              <el-table-column align="center" prop="deviceName" label="设备名称" width="180"></el-table-column>
              <el-table-column align="center" prop="model" label="设备型号" width="180"></el-table-column>
              <el-table-column align="center" prop="factory" label="生产产家" width="180"></el-table-column>
              <el-table-column align="center" prop="address" label="安装位置"></el-table-column>
              <el-table-column align="center" label="操作">
                <template slot-scope="scope">
                  <el-button size="mini" type="success" @click="edit(scope.$index,scope.row)">查询</el-button>
                  <el-button
                    size="mini"
                    type="danger"
                    @click="deleteMsg(scope.$index,tableData2,scope.row)"
                  >解绑设备</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-tab-pane>
        <el-tab-pane name="2">
          <span slot="label">
            <i class="iconfont iconcheck"></i>
            <i class="border"></i> 关联区域
          </span>
          <div class="w_normalNav">
            <button class="GreenSmBtn" @click="contact">新增</button>
          </div>
          <div
            class="table"
            v-loading="loading2"
            element-loading-text="拼命加载中"
            element-loading-spinner="el-icon-loading"
          >
            <el-table :data="areaData" stripe class="stripeTable">
              <el-table-column align="center" prop="name" label="区域名称" width="580"></el-table-column>
              <el-table-column align="center" label="操作">
                <template slot-scope="scope">
                  <el-button size="mini" type="success" @click="edit(scope.$index,scope.row)">查询</el-button>
                  <el-button size="mini" type="danger" @click="deleteArea(scope)">解绑区域</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-tab-pane>
      </el-tabs>
      <el-dialog
        class="editDialog"
        :visible.sync="displayForm1"
        :close-on-click-modal="false"
        :title="title"
      >
        <el-form :model="addEquipment1" v-loading="formloading1">
          <el-form-item label="阈值名称">
            <el-input v-model="addEquipment1.t_name" readonly></el-input>
          </el-form-item>
          <!-- <el-form-item label="方案名称">
            <el-input v-model="addEquipment1.name" readonly></el-input>
          </el-form-item> -->
          <h3>
            <span>联动关联:</span>
          </h3>
          <el-form-item label="设备类型">
            <el-input v-model="addEquipment1.type_name" readonly></el-input>
          </el-form-item>
          <el-form-item label="服务类型">
            <el-input v-model="addEquipment1.service_type" readonly></el-input>
          </el-form-item>
          <el-form-item label="服务名称">
            <el-input v-model="addEquipment1.service_name" readonly></el-input>
          </el-form-item>
          <el-form-item label="指令参数">
            <el-input v-model="addEquipment1.json_params" readonly></el-input>
          </el-form-item>
          <h3>
            <span>指令关联:</span>
          </h3>
          <el-form-item label="指令类型">
            <el-input v-model="addEquipment1.command_type" readonly></el-input>
          </el-form-item>
          <el-form-item label="指令名称">
            <el-input v-model="addEquipment1.command_name" readonly></el-input>
          </el-form-item>
          <el-form-item label="指令参数">
            <el-input v-model="addEquipment1.parameters" readonly></el-input>
          </el-form-item>
        </el-form>
      </el-dialog>
      <el-dialog class="editDialog" :visible.sync="displayForm2">
        <el-form :model="addEquipment2" v-loading="formloading2" :close-on-click-modal="false">
          <el-form-item label="	阈值名称">
            <el-input v-model="addEquipment2.t_name" readonly></el-input>
          </el-form-item>
          <el-form-item label="方案名称">
            <el-input v-model="addEquipment2.name" readonly></el-input>
          </el-form-item>
          <h3>联动关联:</h3>
          <el-form-item label="设备类型">
            <el-input v-model="addEquipment2.type_name" readonly></el-input>
          </el-form-item>
          <el-form-item label="服务类型">
            <el-input v-model="addEquipment2.service_type" readonly></el-input>
          </el-form-item>
          <el-form-item label="服务名称">
            <el-input v-model="addEquipment2.service_name" readonly></el-input>
          </el-form-item>
          <el-form-item label="指令参数">
            <el-input v-model="addEquipment2.json_params" readonly></el-input>
          </el-form-item>
          <h3>指令关联:</h3>
          <el-form-item label="指令类型">
            <el-input v-model="addEquipment2.command_type" readonly></el-input>
          </el-form-item>
          <el-form-item label="指令名称">
            <el-input v-model="addEquipment2.command_name" readonly></el-input>
          </el-form-item>
          <el-form-item label="指令参数">
            <el-input v-model="addEquipment2.parameters" readonly></el-input>
          </el-form-item>
        </el-form>
      </el-dialog>
    </div>
    <router-view></router-view>
  </section>
</template>

<script>
import { Loading } from "element-ui";
export default {
  data() {
    return {
      title: "",
      loading1: true,
      loading2: true,
      formloading1: true,
      formloading2: true,
      displayForm1: false,
      displayForm2: false,
      tableData2: [],
      areaData: [],
      addEquipment1: {
        device_nam: "",
        t_name: "",
        name: "",
        type_name: "",
        service_type: "",
        service_name: "",
        json_params: "",
        command_type: "",
        command_name: "",
        parameters: ""
      },
      addEquipment2: {
        a_name: "",
        command_name: "",
        command_type: "",
        device_name: "",
        json_params: "",
        name: "",
        parameters: "",
        service_name: "",
        service_type: "",
        t_name: "",
        type_name: ""
      },
      relevanceType: "1"
    };
  },
  methods: {
    contact() {
      this.$router.push({
        name: "tridevAdd",
        params: {
          id: this.$route.params.id,
          device_type: this.$route.params.device_type,
          relevanceType: this.relevanceType == "1" ? "device" : "area"
        }
      });
    },
    edit(index, row) {
      //console.log(row, "row");
      this.title = "关联详情";
      this["displayForm" + this.relevanceType] = this[
        "formloading" + this.relevanceType
      ] = true;
      this["addEquipment" + this.relevanceType] = {};
      let params, url;
      if (this.relevanceType == "1") {
        params = {
          d_id: row.deviceId,
          t_id: this.$route.params.id
        };
        url = "operation/tridev/findOne";
      } else {
        params = {
          id: row.id
        };
        url = "operation/TriArea/findOne";
      }
      this.$axiosget(url, { params }).then(res => {
        this["addEquipment" + this.relevanceType] = res.data.data;
        //console.log(this.addEquipment1,"addEquipment1")
        this["formloading" + this.relevanceType] = false;
      });
    },
    deleteMsg(index, data, row) {
      var params = new URLSearchParams();
      params.append("d_id", row.deviceId);
      params.append("t_id", this.$route.params.id);
      this.$confirm("是否解绑该设备?", "删除操作", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$axiospost("operation/deleteTriDev", params).then(res => {
          this.checkData();
          this.$message({
            type: "success",
            message: "删除成功!"
          });
        });
      });
    },
    deleteArea(store) {
      var params = new URLSearchParams();
      params.append("id", store.row.id);
      params.append("a_id", store.row.a_id);
      this.$confirm("是否解绑该区域?", "删除操作", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$axiospost("operation/TriArea/deleteTriArea", params).then(res => {
          this.areaData.splice(store.$index, 1);
          this.$message({
            type: "success",
            message: "删除成功!"
          });
        });
      });
    },
    checkData() {
      this.$axiosget("operation/findTriDev", {
        params: {
          id: this.$route.params.id
        }
      }).then(res => {
        this.tableData2 = res.data.data;
        this.loading1 = false;
      });

      this.$axiosget("operation/TriArea/findAll", {
        params: {
          t_id: this.$route.params.id
        }
      }).then(res => {
        this.areaData = res.data.data;
        this.loading2 = false;
      });
    }
  },
  created() {
    this.checkData();
  }
};
</script>

<style scope lang="less">
  .w_normalNav {
    padding-top: 10px;
    height: 52px;
    position: absolute;
    top: -52px;
    right: 32px;
    z-index: 99;
  }
.main {
  width: 100%;
  height: 100%;
  position: relative;
  padding-top: 21px;
  > .w_breadcrumb {
    padding-left: 37px;
    position: relative;
    background: #0c111b;
    margin-top: -20px;
    .icondqwz {
      font-size: 15px;
      color: #4c6bc3;
      position: absolute;
      left: 22px;
      top: 1px;
    }
    .el-breadcrumb {
      height: 40px;
      line-height: 40px;
      .el-breadcrumb__item:last-child .el-breadcrumb__inner {
        float: left;
        display: inline-block;
        color: #35b9f7;
        cursor: pointer;
        transition: all 0.5s;
      }
      .el-breadcrumb__inner.is-link {
        color: #ccc;
        font-weight: 400;
        margin-left: 10px;
      }
      .el-breadcrumb__inner:hover {
        color: #35b9f7;
      }
    }
  }
  > .seeDetail {
    position: relative;
    .el-button {
      color: #fff;
      background-color: #409eff;
      right: 5px;
      border: none;
      position: absolute;
      z-index: 2;
      top: 5px;
    }
    > .Data {
      width: 70%;
      > .el-form {
        width: 100%;
        display: flex;
        align-items: center;
        > .el-form-item {
          margin: 0;
          align-self: center;
          .el-button {
            color: #fff;
            background-color: #409eff;
            float: right;
            border: none;
          }
        }
      }
    }
  }
  > .d {
    width: 30%;
    min-height: 300px;
    position: absolute;
    top: 20%;
    right: 0;
    padding-right: 20px;
    > .el-form {
      min-height: 400px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      > .el-form-item {
        margin: 0;
        > .el-button {
          width: 100%;
        }
      }
    }
  }
  .editDialog {
    h3 {
      color: #ccc;
      border-bottom: 1px solid #2d374d;
      span {
        font-size: 16px;
        display: inline-block;
        height: 52px;
        line-height: 52px;
        position: relative;
        border-bottom: 2px solid #35b9f7;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute2/systemConfiguration/first/device/tridev/index.vue